export default {
    name: 'places',
    component: () => import(/* webpackChunkName: "places-Layout" */ '@/modules/places/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.places.index',
            component: () => import(/* webpackChunkName: "places-index" */ '@/modules/places/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.places.create',
            component: () => import(/* webpackChunkName: "places-create" */ '@/modules/places/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.places.edit',
            component: () => import(/* webpackChunkName: "places-edit" */ '@/modules/places/views/Edit'),
        },
    ]
}